module.exports = __webpack_public_path__ + "static/optimum-7c2f26d0ebc3786cb076540c2eee8b59.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/optimum.png
// module id = ./src/images/optimum.png
// module chunks = component---src-pages-show-js component---src-pages-new-js component---src-pages-index-js